export const STYLE_GUIDE = {
  page: "style-guide-page",
  healthBadge: "style-guide-health-badge",
  btnGenera: "style-guide-btn-genera",
  btnImporta: "style-guide-btn-importa",
  btnAnnulla: "style-guide-btn-annulla",
  pillPronto: "style-guide-pill-pronto",
  pillInGenerazione: "style-guide-pill-in-generazione",
  pillNonRiuscito: "style-guide-pill-non-riuscito",
  inputDemo: "style-guide-input-demo",
};

export const LANDING = {
  page: "landing-page",
  ctaStyleGuide: "landing-cta-style-guide",
  healthStatus: "landing-health-status",
  showcase: "landing-showcase",
  showcaseTitle: "landing-showcase-title",
  showcaseGrid: "landing-showcase-grid",
  showcaseCard: "landing-showcase-card",
  showcaseVideo: "landing-showcase-video",
};

export const DASHBOARD = {
  page: "dashboard-page",
  newProjectBtn: "dashboard-new-project-btn",
  createForm: "dashboard-create-form",
  inputTitle: "dashboard-input-title",
  inputLogline: "dashboard-input-logline",
  inputStory: "dashboard-input-story",
  submitBtn: "dashboard-submit-btn",
  cancelBtn: "dashboard-cancel-btn",
  projectCard: "dashboard-project-card",
  emptyState: "dashboard-empty-state",
};

export const PROJECT_DETAIL = {
  page: "project-detail-page",
  title: "project-detail-title",
  storyToScenesBtn: "project-story-to-scenes-btn",
  addSceneBtn: "project-add-scene-btn",
  sceneItem: "project-scene-item",
  addReferenceBtn: "project-add-reference-btn",
  referenceItem: "project-reference-item",
  referenceFileInput: "project-reference-file-input",
  referenceImage: "project-reference-image",
  sceneRefToggle: "project-scene-ref-toggle",
  deleteProjectBtn: "project-delete-btn",
  backBtn: "project-back-btn",
  costSummary: "project-cost-summary",
  jobItem: "project-job-item",
};

export const MONTAGGIO = {
  section: "montaggio-section",
  renderBtn: "montaggio-render-btn",
  status: "montaggio-status",
  video: "montaggio-video",
  excluded: "montaggio-excluded",
  empty: "montaggio-empty",
  sceneRow: "montaggio-scene-row",
  trimStart: "montaggio-trim-start",
  trimEnd: "montaggio-trim-end",
  downloadBtn: "montaggio-download-btn",
};
